import { Col, Row } from "reactstrap";
import Collapsable from "../../../components/Collapsable";
import DataTableNested from "../../../components/DataTableNested";
import { formatCurrencyForTable } from "../functions/quoteFunctions";

const SalesforceFieldsTable = ({header, salesforceFields}) => {
    if (salesforceFields.length === 0) return null;           

    const columns = [
        { key: "sortOrder", 
          label: "Field",
          align: "left",
          render: (value, field) => {
              return field.label;
          }
        },        
//        { key: "name", label: "API Name", align: "left"},
        { key: "value", 
          label: "Value", 
          render: (value, field) =>  
            field.type === "currency"
                ? formatCurrencyForTable(value) 
                : value , align: "left"
        },
    ].map(col => ({
        align: "right",
        ...col
    }));

    return (
        <Collapsable header={header} open fluid>
            <Row>
                <Col>
                    <DataTableNested
                        id="salesforce-fields-table"
                        data={salesforceFields}
                        columns={columns}
                        width="auto"
                        sortByColumn="sortOrder"
                    />
                </Col>
            </Row>       
        </Collapsable>  
    );
}
export default SalesforceFieldsTable;